import { Divider, Row } from "antd";
import Text from "@/components/common/Typography/Text";
import { useIsDesktop } from "@/hooks/app/useIsDesktop";
import Link from "@/components/common/LinkNext";
import { useTranslation } from "react-i18next";

type LoginFormFooterProps = {
  onSwitchToSignup?: () => void;
};

const LoginFormFooter = ({ onSwitchToSignup }: LoginFormFooterProps) => {
  const isDesktop = useIsDesktop();
  const { t } = useTranslation()

  return (
    <Row justify="center" className="form-login--noaccount">
      <Divider style={{ marginBottom: "1.6rem", marginTop: 0 }} />
      <Text>
        {t("auth.register_prompt")}{" "}
        {isDesktop ? (
          <a
            onClick={(e) => {
              e.preventDefault();
              if (onSwitchToSignup) {
                onSwitchToSignup();
              }
            }}
            style={{ cursor: "pointer" }}
          >
            {t("common.register")}
          </a>
        ) : (
          <Link href="/signup">{t("common.register")}</Link>
        )}
        .
      </Text>
    </Row>
  );
};

export default LoginFormFooter;